import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number, trail: string): string {
    const l = (limit) ? limit : 10;
    const t = (trail) ? trail : '…';

    return (value.length > l) ? value.substring(0, l) + t : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/pipes/truncate.pipe.ts